export default {
  ACTIONS_MENU: "fa-solid fa-ellipsis-vertical",
  ARROW_DOUBLE_LEFT: "fa-solid fa-angles-left",
  ARROW_DOUBLE_RIGHT: "fa-solid fa-angles-right",
  ARROW_LEFT: "fa-solid fa-angle-left",
  ARROW_RIGHT: "fa-solid fa-angle-right",
  CHECK: "fa-solid fa-check",
  HAMBURGER_NAV: "fa-solid fa-bars",
  PALETTE: "fa-solid fa-palette",
  SEARCH: "fa-solid fa-magnifying-glass",
};
